import Icon from '../../../components/AppIcon';
import type { ContactInfo } from '../types';

interface ContactInfoCardProps {
  info: ContactInfo;
}

const ContactInfoCard = ({ info }: ContactInfoCardProps) => {
  return (
    <a
      href={info.href}
      className="flex items-start gap-4 p-6 rounded-xl bg-surface hover:bg-surface/80 transition-all duration-300 group border border-border hover:border-accent/50"
      aria-label={`Contact via ${info.label}`}
    >
      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gradient-accent flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        <Icon name={info.icon} size={24} color="var(--color-text-primary)" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-medium text-secondary mb-1">{info.label}</h3>
        <p className="text-base font-semibold text-primary break-words">{info.value}</p>
      </div>
    </a>
  );
};

export default ContactInfoCard;